import { defineComponent as _defineComponent } from 'vue'
import UiCalendar from '../../components/calendar.vue';
import { type DayCell } from '../../datepicker';


const __default__ = {
    name: 'UiDatepickerDateTime',
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    cells: null,
    title: null,
    showMonthPicker: { type: Boolean, default: false },
    viewYear: { default: 0 },
    viewMonth: { default: 0 },
    timeStr: null,
    timeFormat: null,
    onlyHours: { type: Boolean, default: false },
    footerTimeStr: { default: '' },
    footerInputStr: { default: '' }
  },
  emits: ["prev", "next", "toggle-month-picker", "day-click", "day-hover", "day-leave", "prev-year", "next-year", "select-view-month", "time-change", "footer-time-input", "footer-time-change", "footer-input", "footer-change", "reset", "apply"],
  setup(__props: any) {





return { __sfc: true,UiCalendar }
}

})